import React from "react";
import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  addCrewTimeEntry,
  getCostCodesByProjectId,
  getProjectTask,
  // getUserDetails,
  getCostCodes,
} from "../API";
import {
  getCurrentDateTime,
  formatDateToYYYYMMDD,
  getDatesForISOWeek,
  formatTimeEntry,
  convertTimesToMinutes,
} from "../utils/utils";
import TimePickerComponent from "./TimePicker";
import useFetch from "./AddCrew";
import AddNewTeamMemberModal from "./AddNewTeamMemberModal";
import "react-datepicker/dist/react-datepicker.css";
import AddNewEquipmentModal from "./AddNewEquipmentModal";
import SubmissionWarningModal from "./modal/SubmissionWarningModal";
import { IsTimeSheetStatusChanged } from "../utils/apiUtils";
import "../assets/styles/time-entry-drawer.scss";

const CommonTimeEntryModal = React.memo((props) => {
  const {
    crew_id,
    project_id,
    addCrewModal,
    entryType,
    getTimeSheetWeekDetails,
    timeSheetDetails,
    setIsErrorModal,
    setFailedUserEntries,
    setFailedEquipmentEntries,
    toggleModalFunc,
  } = props;
  const {
    crewUsers,
    crewEquipments,
    projectOptions,
    onClickAddCrewTimeDate,
    fetchEquipmentList,
    teamMemberLoading,
    equipmentLoading,
  } = useFetch(addCrewModal, crew_id, project_id, entryType);

  const themeData = JSON.parse(localStorage.getItem("themeData"));
  // const [costCodesOptions, setCostCodesOptions] = useState([]);
  const [selectedDate, setSelectedDate] = useState({
    selectedDateLabel: "",
    selectedDateValue: "",
  });
  const [time, setTime] = useState({
    punchIn: { hours: 12, minutes: "00", ampm: "PM" },
    punchOut: { hours: 12, minutes: "30", ampm: "PM" },
    workingTimeIn: { hours: 6, minutes: "00", ampm: "AM" },
    workingTimeOut: { hours: 4, minutes: "30", ampm: "PM" },
  });
  const [notes, setNotes] = useState();
  const [lunchToggle, setLunchToggle] = useState(false);
  const [allSelectedUsers, setAllSelectedUsers] = useState([]);
  const [projectTaskOptions, setProjectTaskOptions] = useState([]);
  const [selectedCostCode, setSelectedCostCode] = useState();
  const [selectedProjectTask, setSelectedProjectTask] = useState();
  const [toggleAddNewMember, setToggleAddNewMember] = useState(false);
  const [selectedProject, setSelectedProject] = useState();
  const [projectCostCodes, setProjectCostCodes] = useState([]);
  const [dropDownLoading, setDropDownLoading] = useState(false);
  const [allSelectedEquipments, setAllSelectedEquipments] = useState([]);
  const [toggleAddNewEquipment, setToggleAddNewEquipment] = useState(false);
  const [perDiem, setPerDiem] = useState(false);
  const [submissionWarningModal, setSubmissionWarningModal] = useState(false);

  const resetFields = () => {
    setSelectedDate({
      selectedDateLabel: "",
      selectedDateValue: "",
    });
    setNotes("");
    setTime({
      punchIn: { hours: 12, minutes: "00", ampm: "PM" },
      punchOut: { hours: 12, minutes: "30", ampm: "PM" },
      workingTimeIn: { hours: 6, minutes: "00", ampm: "AM" },
      workingTimeOut: { hours: 4, minutes: "30", ampm: "PM" },
    });
    setProjectTaskOptions([]);
    setProjectCostCodes([]);
    setToggleAddNewMember(false);
    setLunchToggle(false);
    setSelectedProject(null);
    setSelectedProjectTask(null);
    setSelectedCostCode(null);
    setAllSelectedUsers(crewUsers);
    setAllSelectedEquipments(crewEquipments);
  };

  useEffect(() => {
    const myOffcanvas = document.getElementById("timeEntryModal");
    if (myOffcanvas && addCrewModal) {
      const handleHidden = () => toggleModalFunc();

      myOffcanvas.addEventListener("hidden.bs.offcanvas", handleHidden);

      return () => {
        myOffcanvas.removeEventListener("hidden.bs.offcanvas", handleHidden);
      };
    }
  }, [addCrewModal, toggleModalFunc]);

  useEffect(() => {
    if (selectedProject?.value?.id) {
      getAllProjectTasks(selectedProject?.value?.id);
    }
  }, [selectedProject?.value?.id]);

  const getAllProjectTasks = async (id) => {
    setDropDownLoading(true);
    await getProjectTask(id).then((res) => {
      if (res?.status === 200) {
        const dropDownOptions = res?.data?.map((ele) => {
          return { label: ele?.description, value: ele };
        });
        setProjectTaskOptions(dropDownOptions);
      }
      setDropDownLoading(false);
    });
  };

  const fetchCostCodes = async (item) => {
    setDropDownLoading(true);
    const payload = {
      id: selectedProject?.value?.id,
      is_default: true,
      query: `project_task_id=${item?.value?.id}`,
    };
    await getCostCodesByProjectId(
      payload?.id,
      payload?.is_default,
      payload?.query
    ).then((res) => {
      if (res?.data?.length > 0) {
        const projectCostCodeOptions = res?.data?.map((costCode) => {
          return { label: costCode?.description, value: costCode };
        });
        setProjectCostCodes(projectCostCodeOptions);
      }
      setDropDownLoading(false);
    });
  };

  useEffect(() => {
    if (crewUsers) {
      setAllSelectedUsers(crewUsers);
    }
  }, [crewUsers]);

  useEffect(() => {
    if (crewEquipments) {
      setAllSelectedEquipments(crewEquipments);
    }
  }, [crewEquipments]);

  // useEffect(() => {
  //   if (crew_id) {
  //     getAllCostCodes();
  //   }
  // }, []);

  const handleTimeSelectChange = (field, value, type) => {
    const copiedTime = { ...time };
    copiedTime[type][field] = value;
    setTime(copiedTime);
  };

  const onHandleChange = async (item) => {
    setSelectedProject(item);
    if (item?.value?.type === "webtime") {
      await getCostCodes(item?.value?.id).then((res) => {
        if (res?.data) {
          const tempCostCodes = res?.data?.map((ele) => {
            return {
              label: ele?.description,
              value: ele,
            };
          });
          setProjectCostCodes(tempCostCodes);
          setSelectedProjectTask(null);
          setSelectedCostCode(null);
        }
      });
    } else {
      setProjectCostCodes(null);
      setSelectedProjectTask(null);
      setSelectedCostCode(null);
    }
  };

  // const getAllCostCodes = async () => {
  //   await getCrewCostCodes(crew_id, "user").then((res) => {
  //     if (res?.status === 200) {
  //       console.log("getCrewCostCodes ==>", res?.data);
  //       const costCodes = res?.data?.map((ele) => ({
  //         label: ele?.project_cost_code?.description,
  //         value: ele,
  //       }));
  //       setCostCodesOptions(costCodes);
  //     }
  //   });
  // };

  const onChangeUserSelect = (item) => {
    setAllSelectedUsers(item);
  };

  const onDateChange = (e) => {
    const date = formatDateToYYYYMMDD(e);
    setSelectedDate({ selectedDateLabel: e, selectedDateValue: date });
  };

  const onProjectTaskChange = (item) => {
    setSelectedProjectTask(item);
    if (selectedProject?.value?.type === "acumatica") {
      setProjectCostCodes(null);
      setSelectedCostCode(null);
      fetchCostCodes(item);
    }
  };

  const onCostCodeChange = (item) => {
    setSelectedCostCode(item);
  };

  const onTogglePerDiem = async (e) => {
    const isChecked = e.target.checked;
    setPerDiem(isChecked);
    // const id = selectedUserValue?.time_entry_id;
    // const payload = {
    //   is_stepup_foreman: isChecked,
    // };
    // await updateTimeEntry(payload, id)
    //   .then((res) => {
    //     if (res?.status === 200) {
    //       toast.success("Updated Successfully");
    //     }
    //   })
    //   .catch((err) => toast.error("Error occured while updating"));
  };

  const onClickSave = async () => {
    if (
      (selectedDate.selectedDateLabel || selectedDate.selectedDateValue) &&
      (allSelectedUsers?.length > 0 || allSelectedEquipments?.length > 0) &&
      selectedCostCode?.value?.id &&
      selectedProjectTask?.value?.id &&
      selectedProject?.value?.id
    ) {
      const entryTimeIn = formatTimeEntry(time?.workingTimeIn, "entryTimeIn");
      const entryTimeOut = formatTimeEntry(
        time?.workingTimeOut,
        "entryTimeOut"
      );
      const lunchTimeIn = formatTimeEntry(time?.punchIn, "lunchTimeIn");
      const lunchTimeOut = formatTimeEntry(time?.punchOut, "lunchTimeOut");
     
      if (
        convertTimesToMinutes(entryTimeIn) -
          convertTimesToMinutes(entryTimeOut) >=
          0 ||
        convertTimesToMinutes(entryTimeIn) -
          convertTimesToMinutes(entryTimeOut) ===
          -24 ||
        convertTimesToMinutes(entryTimeIn) ===
          convertTimesToMinutes(entryTimeOut) ||
        (lunchToggle &&
          (convertTimesToMinutes(lunchTimeIn) -
            convertTimesToMinutes(lunchTimeOut) >=
            0 ||
            convertTimesToMinutes(lunchTimeIn) -
              convertTimesToMinutes(lunchTimeOut) ===
              -24 ||
            convertTimesToMinutes(lunchTimeIn) -
              convertTimesToMinutes(entryTimeIn) <
              0 ||
            convertTimesToMinutes(lunchTimeIn) -
              convertTimesToMinutes(entryTimeOut) >
              0 ||
            convertTimesToMinutes(lunchTimeOut) -
              convertTimesToMinutes(entryTimeIn) <
              0 ||
            convertTimesToMinutes(lunchTimeOut) -
              convertTimesToMinutes(entryTimeOut) >
              0))
      ) {
        toast.warn("Invalid time-range for work or lunch");
      } else {
        const timeSheetStatusChanged = await IsTimeSheetStatusChanged(
          timeSheetDetails?.id
        );
        if (timeSheetStatusChanged) {
          setSubmissionWarningModal(true);
          return;
        } else {
          allSelectedUsers?.forEach(async (ele) => {
            const payload = {
              project_id: selectedProject?.value?.id,
              time_entry_in: entryTimeIn,
              time_entry_out: entryTimeOut,
              time_lunch_start: lunchToggle ? lunchTimeIn : null,
              time_lunch_end: lunchToggle ? lunchTimeOut : null,
              entry_time: getCurrentDateTime(),
              time_entry_type_id: 1,
              crew_user_equipment_id: ele?.value?.crew_user_id,
              crew_id,
              time_entry_date: selectedDate?.selectedDateValue || "",
              is_crew_entry: true,
              time_entry_status_id: 1,
              project_task_id: selectedProjectTask?.value?.id,
              project_cost_code_id: selectedCostCode?.value?.id,
              time_sheet_id: timeSheetDetails?.id,
              notes,
              perDiem,
            };
            await addCrewTimeEntry(payload)
              .then((res) => {
                if (res?.data) {
                  // toast.success("User time entry added successfully.");
                  getTimeSheetWeekDetails(timeSheetDetails);
                  resetFields();
                } else {
                  setFailedUserEntries((prevState) => [
                    ...prevState,
                    res?.response?.data?.errors[0],
                  ]);
                  setIsErrorModal(true);
                  getTimeSheetWeekDetails(timeSheetDetails);
                  resetFields();
                }
              })
              .catch((err) => {
                console.log("addCrewTimeEntryaddCrewTimeEntry", err);
              });
          });

          allSelectedEquipments?.forEach(async (ele) => {
            const payload = {
              project_id: selectedProject?.value?.id,
              time_entry_in: entryTimeIn,
              time_entry_out: entryTimeOut,
              time_lunch_start: lunchToggle ? lunchTimeIn : null,
              time_lunch_end: lunchToggle ? lunchTimeOut : null,
              entry_time: getCurrentDateTime(),
              time_entry_type_id: 2,
              crew_user_equipment_id: ele?.value?.id,
              crew_id,
              time_entry_date: selectedDate?.selectedDateValue || "",
              is_crew_entry: true,
              time_entry_status_id: 1,
              project_task_id: selectedProjectTask?.value?.id,
              time_sheet_id: timeSheetDetails?.id,
              notes,
            };

            await addCrewTimeEntry(payload)
              .then((res) => {
                if (res?.data) {
                  // toast.success("Equipment time entry successfully added.");
                  getTimeSheetWeekDetails(timeSheetDetails);
                  resetFields();
                } else {
                  setFailedEquipmentEntries((prevState) => [
                    ...prevState,
                    res?.response?.data?.errors[0],
                  ]);
                  setIsErrorModal(true);
                  getTimeSheetWeekDetails(timeSheetDetails);
                  resetFields();
                }
              })
              .catch((err) => toast.error("Unable to add time entry"));
          });
        }
      }
    } else {
      toast.warning("Please fill all the required fields");
    }
  };

  const onChangeEquipmentSelect = (item) => {
    setAllSelectedEquipments(item);
  };

  return (
    allSelectedUsers && (
      <>
        <div
          className="offcanvas offcanvas-end crew-mdal"
          tabindex="-1"
          id="timeEntryModal"
          aria-labelledby="timeEntryModalLabel"
        >
          <div className="offcanvas-header">
            <h3 id="timeEntryModalLabel">User & Equipment Time Entry</h3>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={() => resetFields()}
            ></button>
          </div>
          <div className="offcanvas-body">
            <div className="time-entry-field">
              <label htmlFor="" className="time-entry-label">
                Project *
              </label>
              <Select
                placeholder="Select Project"
                value={selectedProject}
                className="react-select-container"
                classNamePrefix="react-select"
                name="colors"
                options={projectOptions}
                onChange={(item) => onHandleChange(item)}
              />
            </div>
            <div className="time-entry-field">
              <label htmlFor="" className="time-entry-label">
                Date *
              </label>
              <DatePicker
                placeholderText="YYYY/MM/DD"
                default
                selected={selectedDate.selectedDateLabel}
                onChange={(e) => onDateChange(e)}
                dateFormat="yyyy/MM/dd"
                aria-label="Date"
                className="input-field"
                includeDates={
                  Object.keys(timeSheetDetails).length > 0
                    ? getDatesForISOWeek(timeSheetDetails?.week)
                    : ""
                }
              />
            </div>
            <div className="time-entry-field">
              <label htmlFor="" className="time-entry-label">
                Team Members *
              </label>
              <Select
                isLoading={teamMemberLoading}
                defaultValue={allSelectedUsers}
                value={allSelectedUsers}
                className="react-select-container-members"
                classNamePrefix="react-select"
                isMulti
                name="colors"
                options={crewUsers}
                onChange={(item) => onChangeUserSelect(item)}
              />
            </div>
            <div className="time-entry-add-row">
              <button
                onClick={() => setToggleAddNewMember(true)}
                type="button"
                className="time-entry-add-link"
                data-bs-toggle="modal"
                data-bs-target="#addNewTeamMember"
              >
                + Add New Team Member
              </button>
            </div>
            <div className="time-entry-field">
              <label htmlFor="" className="time-entry-label">
                Equipment *
              </label>
              <Select
                isLoading={equipmentLoading}
                className="react-select-container"
                defaultValue={allSelectedEquipments}
                value={allSelectedEquipments}
                classNamePrefix="react-select"
                isMulti
                name="colors"
                options={crewEquipments}
                onChange={(item) => onChangeEquipmentSelect(item)}
              />
            </div>
            <div className="time-entry-add-row">
              <button
                onClick={() => setToggleAddNewEquipment(true)}
                type="button"
                className="time-entry-add-link"
                data-bs-toggle="modal"
                data-bs-target="#addNewEquipment"
              >
                + Add New Equipment
              </button>
            </div>
            <div className="time-entry-field">
              <label htmlFor="" className="time-entry-label">
                Project Task *
              </label>
              <Select
                value={selectedProjectTask}
                isLoading={dropDownLoading}
                className="react-select-container"
                classNamePrefix="react-select"
                name="colors"
                options={projectTaskOptions}
                onChange={(item) => onProjectTaskChange(item)}
              />
            </div>
            <div className="time-entry-field">
              <label htmlFor="" className="time-entry-label">
                Cost Code *
              </label>
              <Select
                value={selectedCostCode}
                isLoading={dropDownLoading}
                className="react-select-container"
                classNamePrefix="react-select"
                name="colors"
                options={projectCostCodes}
                onChange={(item) => onCostCodeChange(item)}
              />
            </div>
            <div className="time-entry-field">
              <label htmlFor="" className="time-entry-label">
                Working Time *
              </label>
              <div className="time-entry-time-row d-flex align-items-center justify-content-between row">
                <div className="col-6">
                  <TimePickerComponent
                    label={"Start"}
                    time={time?.workingTimeIn}
                    type="workingTimeIn"
                    handleTimeSelectChange={handleTimeSelectChange}
                    orientation="top"
                  />
                </div>
                <div className="col-6">
                  <TimePickerComponent
                    label={"End"}
                    time={time?.workingTimeOut}
                    type="workingTimeOut"
                    handleTimeSelectChange={handleTimeSelectChange}
                    orientation="top"
                  />
                </div>
              </div>
            </div>
            {themeData?.is_per_diem === "true" && (
              <div className="time-entry-field time-entry-perdiem">
                <span className="time-entry-label">Per diem</span>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input toggle-switch"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckDefault"
                    onClick={(e) => onTogglePerDiem(e)}
                  />
                </div>
              </div>
            )}
            <div className="time-entry-field">
              <label htmlFor="" className="time-entry-label">
                Notes
              </label>
              <textarea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                rows="3"
                className="textarea"
              />
            </div>
            <div className="time-entry-field">
              <button
                onClick={() => setLunchToggle((prevState) => !prevState)}
                type="button"
                className="primary-btn lunch time-entry-lunch-btn"
              >
                Lunch / Break
              </button>
              {lunchToggle && (
                <div className="time-entry-time-row d-flex align-items-center justify-content-between row mt-2">
                  <div className="col-6">
                    <TimePickerComponent
                      orientation="top"
                      label={"Start"}
                      time={time?.punchIn}
                      type="punchIn"
                      entryType="lunch"
                      handleTimeSelectChange={handleTimeSelectChange}
                    />
                  </div>
                  <div className="col-6">
                    <TimePickerComponent
                      orientation="top"
                      label={"End"}
                      time={time?.punchOut}
                      type="punchOut"
                      entryType="lunch"
                      handleTimeSelectChange={handleTimeSelectChange}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button
              onClick={() => resetFields()}
              type="button"
              className="primary-btn-outlined"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              Cancel
            </button>
            <button
              onClick={() => onClickSave()}
              type="button"
              className="primary-btn"
              data-bs-dismiss={"offcanvas"}
            >
              Save
            </button>
          </div>
        </div>
        <AddNewTeamMemberModal
          onClickAddCrewTimeDate={onClickAddCrewTimeDate}
          setToggleAddNewMember={setToggleAddNewMember}
          toggleAddNewMember={toggleAddNewMember}
          crewUsers={crewUsers}
          crew_id={crew_id}
          allSelectedUsers={allSelectedUsers}
          setAllSelectedUsers={setAllSelectedUsers}
        />
        <AddNewEquipmentModal
          crew_id={crew_id}
          toggleAddNewEquipment={toggleAddNewEquipment}
          setToggleAddNewEquipment={setToggleAddNewEquipment}
          crewEquipments={crewEquipments}
          fetchEquipmentList={fetchEquipmentList}
          allSelectedEquipments={allSelectedEquipments}
          setAllSelectedEquipments={setAllSelectedEquipments}
        />
        <SubmissionWarningModal isOpen={submissionWarningModal} />
      </>
    )
  );
});

export default CommonTimeEntryModal;
